import ReportsFolderSidebar from 'modules/reports/components/Folder/Sidebar'
import ReportsIndex from 'modules/reports/components/Index'
import ReportsNav from 'modules/reports/components/Nav'
import ReportsPage from 'modules/reports/components/Page'
import BagContext from 'modules/reports/contexts/bag/BagContext'
import useBag from 'modules/reports/hooks/bag'
import useCore from 'modules/reports/hooks/core'
import SearchContext from 'modules/reports/hooks/search/useSearch.context'
import Report from 'modules/reports/models/Report'
import ReportFolder from 'modules/reports/models/ReportFolder'
import authStore from 'modules/reports/stores/auth'
import React, {useState} from 'react'
import useReportsIndexPageSearch, {
  useReportsIndexPageSearchContext,
} from './ReportsIndexPage.search'
import useStyles from './ReportsIndexPage.styles'

function ReportsIndexPage() {
  const classes = useStyles()
  const {p, pt} = useCore('reports', 'pages', 'Index')
  const searchContext = useReportsIndexPageSearchContext()
  const bag = useBag<Report>()
  const [folders, setFolders] = useState<ReportFolder[]>([])

  function handleSelectFolder(folder: ReportFolder) {
    searchContext.setFilter('folder_id', folder.id)
  }

  return (
    <ReportsPage data-testid={p()}>
      <BagContext.Provider value={bag}>
        <ReportsNav />

        <div className={classes.horizontalWrapper}>
          <ReportsFolderSidebar
            className={classes.sidebar}
            folders={folders}
            folderId={searchContext.filters.folder_id}
            onSelect={handleSelectFolder}
            onChange={setFolders}
          />

          <ReportsIndex
            className={classes.content}
            title={searchContext.folder.name}
            newHref="/reports/new"
            newButtonText={pt('new-report')}
          />
        </div>
      </BagContext.Provider>
    </ReportsPage>
  )
}

export default function() {
  const search = useReportsIndexPageSearch(authStore.user.account_id)

  return (
    <SearchContext.Provider value={search}>
      <ReportsIndexPage />
    </SearchContext.Provider>
  )
}
